import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '../../../../.muji/store';
import { Button } from 'antd';
import { DetailInfo } from '../../../../components/index';
import { Container, Root, Tag, Line } from './_style/index';
import EndAction from '../Auctioneer/_components/EndAction';
import { judgeCanFullScreen, isFullScreen, fullScreen, dealValueShow, toNumber, judgeArr, onResize } from '../../../../shared/functions';
import { CarImgs, BeforeAuction, CarLevel } from './_components';
import Sleep from '@/shared/noSleep';
const sleep = new Sleep();
import { isListenLong, addPollingMechanism } from '@/shared/screenAndLongLinkConfig';
import { NextCar } from '../Auctioneer/_components';
const mapStateToProps = (rootState) => ({
    _state: rootState.screen,
});
class Screen extends Component {
    constructor(props) {
        super(props);
        this.changeFull = (event) => {
            if (!isFullScreen()) {
                // 处理浏览器最大化的时候，clientHeight计算不及时的问题
                setTimeout(() => {
                    this.onResize();
                }, 0);
                // 处理全屏按钮显示 防止因esc导致的按钮不一致
                this.setState({
                    isFull: isFullScreen(),
                });
            }
        };
        /**
         * @desc 窗口变更调用的函数
         */
        this.onResize = () => {
            // 窗口比例接近4:3的时候，处理细节展示
            const width = window.innerWidth || document.documentElement.clientWidth
                || document.body.clientWidth;
            const height = window.innerHeight || document.documentElement.clientHeight
                || document.body.clientHeight;
            const scale = height / width > 0.7;
            this.setState({
                isFourToThree: scale ? true : false,
            });
            // 实际区域宽高
            const designSizeH = !!this.props.isAuctioneer ? 560 : 686;
            onResize('_screen', designSizeH);
        };
        /**
         * @desc 获取竞价状态以及对应样式
         * 状态有 竞拍中|模拟竞拍中|竞拍暂停|10s后结束竞拍|模拟竞拍结束|本车竞拍结束|本场竞拍结束
         *       |10s后结束应价|应价暂停|应价结束
         */
        this.getBidStatus = () => {
            const { isFormal, countNum, isTheLast, carResult, countDownStatus, } = this.props._state;
            const _countNum = countNum ? (countNum < 0 ? 0 : countNum) : 0;
            switch (carResult) {
                case 3:
                    if (countDownStatus) {
                        return ['bidStatus--yellow', `${_countNum}s后结束竞拍`];
                    }
                    return ['bidStatus--yellow', isFormal ? '竞拍中' : '模拟竞拍中'];
                case 30:
                    return ['bidStatus--grey', '竞拍暂停'];
                case 4:
                    return ['bidStatus--grey', isFormal ? (isTheLast ? '本场竞拍结束' : '本车竞拍结束') : '模拟竞拍结束'];
                case 8:
                case 81:
                    return ['bidStatus--yellow', `${_countNum}s后结束应价`];
                case 80:
                    return ['bidStatus--grey', '应价暂停'];
                case 6:
                case 50:
                case 51:
                case 5:
                    return ['bidStatus--grey', isFormal ? (isTheLast ? '本场竞拍结束' : '本车竞拍结束') : '正式竞拍即将开始'];
            }
            return ['', ''];
        };
        /**
         * @desc 获取价格状态 和 价格
         * 状态有    起拍价|当前最高价|成交价|应锤价
         * 价格对应  起拍价|当前最高价|成交价|应锤价
         */
        this.getPriceInfo = () => {
            const { carResult, currentPrice, answerPrice, beginPrice, auctionStageHasBid, auctionMode, auctionHighestDisplay, } = this.props._state;
            if (carResult === 5) {
                return { priceStatus: '成交价', price: currentPrice };
            }
            if ((carResult === 8 || carResult === 80 || carResult === 81) && answerPrice) {
                return { priceStatus: '应锤价', price: answerPrice };
            }
            if (!auctionStageHasBid && (!(carResult === 6 || carResult === 50 || carResult === 51))) {
                return { priceStatus: '起拍价', price: beginPrice };
            }
            /** 超级拍现场拍展示当前最高价priceStatus条件：开启竞拍最高价提醒 */
            /** 现场拍正常展示当前最高价priceStatus */
            if (auctionMode === 1011 && auctionHighestDisplay === 0) {
                return { price: auctionStageHasBid ? currentPrice : beginPrice };
            }
            return { priceStatus: '当前最高价', price: auctionStageHasBid ? currentPrice : beginPrice };
        };
        /**
         * @desc 处理车辆详情信息的数据结构
         */
        this.getContent = () => {
            const { carInfo } = this.props._state;
            const { type, license, emission, address, transmission, changeNum, mileage, onDate, } = carInfo;
            const { isAuctioneer } = this.props;
            if (isAuctioneer) {
                return [
                    [{ key: '<span>类&emsp;&emsp;型</span>', value: dealValueShow(type) },
                        { key: '<span>车&emsp;&emsp;牌</span>', value: dealValueShow(license) }],
                    [{ key: '排放标准 ', value: dealValueShow(emission) },
                        { key: '<span>所&nbsp;&nbsp;在&nbsp;&nbsp;地</span>', value: dealValueShow(address) }],
                    [{ key: '<span>变&nbsp;&nbsp;速&nbsp;&nbsp;箱</span>', value: dealValueShow(transmission) },
                        { key: '过户次数', value: dealValueShow(changeNum, '次') }],
                    [{ key: '<span>里&emsp;&emsp;程</span>', value: dealValueShow(mileage, '万公里') },
                        { key: '出厂日期', value: dealValueShow(onDate) }],
                ];
            }
            return [
                [{ key: '<span>类&emsp;&emsp;型</span>', value: dealValueShow(type) },
                    { key: '<span>车&emsp;&emsp;牌</span>', value: dealValueShow(license) },
                    { key: '排放标准 ', value: dealValueShow(emission) }],
                [{ key: '<span>所&nbsp;&nbsp;在&nbsp;&nbsp;地</span>', value: dealValueShow(address) },
                    { key: '<span>变&nbsp;&nbsp;速&nbsp;&nbsp;箱</span>', value: dealValueShow(transmission) },
                    { key: '过户次数', value: dealValueShow(changeNum, '次') }],
                [{ key: '<span>里&emsp;&emsp;程</span>', value: dealValueShow(mileage, '万公里') },
                    { key: '出厂日期', value: dealValueShow(onDate) }, { key: '', value: '' }],
            ];
        };
        /**
         * @desc 获取center right的样式
         */
        this.getClassContainer = () => {
            const { carResult, bidType, biddingStage } = this.props._state;
            switch (carResult) {
                case 6:
                    return 'style--abortive';
                case 50:
                case 51:
                    return 'style--waitDeal';
                case 5:
                    /** 成交依据(bidType(0:现场，1:远程)|biddingStage(1:投标阶段，2:竞拍阶段))区分 投标成交|远程成交|现场成交 */
                    if (biddingStage === 1) {
                        return 'style--deal__tender';
                    }
                    return bidType === 0 ? 'style--deal__scence' : 'style--deal__net';
                default:
                    return '';
            }
        };
        /**
         * @desc 获取center right的价格样式
         */
        this.getClassPrice = () => {
            const { exceedBasePrice } = this.props._state;
            switch (exceedBasePrice) {
                case 1:
                    return 'price--green';
                case 2:
                    return 'price--red';
                case 3:
                    return 'price--yellow';
                default:
                    return '';
            }
        };
        /**
         * @desc 展示：价格
         */
        this.getCurrentPrice = (price) => {
            const { exceedBasePrice } = this.props._state;
            let styleClass;
            switch (exceedBasePrice) {
                case 1:
                    styleClass = 'price--green';
                    break;
                case 2:
                    styleClass = 'price--red';
                    break;
                case 3:
                    styleClass = 'price--yellow';
                    break;
                default:
                    styleClass = '';
            }
            return (<div className="flex__row-btE r-currentPrice" style={{ width: '100%' }}>
        <span className={`r-priceC ${styleClass}`}>{price}</span>
        <span className="r-priceC__desc">万元</span>
      </div>);
        };
        /**
         * @desc 大屏中标签展示：出价类型领先|与保留价关系|与暗拍价关系   auctionMode需增加与暗拍价的关系 moreThanTender 是否超过投标最高价 0 低于 1 高于
         */
        this.getTags = () => {
            const { isAuctioneer } = this.props;
            const { auctionStageHasBid, bidType, exceedBasePrice, auctionMode, moreThanTender, compareWithTenderDisplay, } = this.props._state;
            if (isAuctioneer) {
                return (<div className={'r-priceS'}/>);
            }
            const tempArr = [];
            // 如有人出价 展示远程或现场领先
            if (auctionStageHasBid) {
                tempArr.push(bidType === 1 ? '远程领先' : '现场领先');
            }
            // 显示与保留价的关系
            let _text = '';
            switch (exceedBasePrice) {
                case 1:
                    _text = '高于保留价';
                    break;
                case 2:
                    _text = '低于保留价';
                    break;
                case 3:
                    _text = '接近保留价';
                    break;
            }
            if (_text) {
                tempArr.push(_text);
            }
            // 如果是超级拍（现场拍）且开启竞拍最高价提醒：显示与投标最高价的关系
            let _text2 = '';
            if (auctionMode === 1011 && compareWithTenderDisplay === 1) {
                switch (moreThanTender) {
                    case 0:
                        _text2 = '低于投标价';
                        break;
                    case 1:
                        _text2 = '高于投标价';
                        break;
                }
                if (_text2) {
                    tempArr.push(_text2);
                }
            }
            return (<div className={'r-priceS flex__row-start'}>
        {tempArr.map((item, i) => <Tag key={i} style={{ marginRight: '0.16rem' }}>{item}</Tag>)}
      </div>);
        };
        /**
         * @desc 展示：合手价|佣金|服务费
         */
        this.getPrices = () => {
            const { isAuctioneer } = this.props;
            const { finalOfferW, brokerageW, commissionW } = this.props._state;
            const getSerAndCom = () => {
                const unit = '万元';
                const tempArr = [{ title: '佣金', price: brokerageW }, { title: '服务费', price: commissionW }];
                const dealArr = tempArr.filter(item => toNumber(item.price) > 0);
                if (!judgeArr(dealArr)) {
                    return null;
                }
                const finalArr = dealArr.map(item => item.title + item.price + unit);
                const finalContent = `(${finalArr.join(' ')})`;
                return (<span className={'r-priceYF'}>
          {finalContent}
        </span>);
            };
            return (<div className="flex__column-btS getPrices">
        <Line isAuctioneer={isAuctioneer}/>
        <div>
          <span className={'r-priceH'}>合手价{finalOfferW}万元 </span>
          {getSerAndCom()}
        </div>
      </div>);
        };
        this.toggleFullScreen = () => {
            this.setState({
                isFull: !isFullScreen(),
            });
            const s = document.getElementById('_screenOuter');
            // 浏览器是否支持全屏
            if (judgeCanFullScreen()) {
                s.style.position = 'relative';
                s.style.top = null;
                s.style.left = null;
                s.style.zIndex = '1';
                fullScreen(s);
            }
            else {
                const { isFull } = this.state;
                s.style.position = isFull ? 'relative' : 'absolute';
                s.style.top = isFull ? null : '0';
                s.style.left = isFull ? null : '0';
                s.style.zIndex = '10';
                this.onResize();
            }
        };
        this.state = {
            isFourToThree: false,
            isFull: false,
        };
    }
    componentWillMount() {
        // 设置html rem值
        window.addEventListener('resize', this.onResize, false);
        // 容错处理
        window.addEventListener('fullscreenchange', this.changeFull, false);
        window.addEventListener('mozfullscreenchange', this.changeFull, false);
        window.addEventListener('webkitfullscreenchange', this.changeFull, false);
        window.addEventListener('msfullscreenchange', this.changeFull, false);
        // 获取场次信息 车辆信息 出价信息 竞拍结果信息 竞拍状态信息
        // 通过页面query里的场次id来挨个获取信息
        dispatch.screen.load({ first: true });
        const { isAuctioneer } = this.props;
        if (isAuctioneer) {
            dispatch.longLinkListen.listen({});
        }
        else {
            if (isListenLong) {
                dispatch.longLinkListen.listen({});
            }
            else {
                dispatch.screenDetailLoop.loop({});
            }
        }
    }
    componentDidMount() {
        this.onResize();
        // 界面持续weak
        const { isAuctioneer } = this.props;
        isAuctioneer ? '' : sleep.wake();
        // 处理计算不准确的问题
        setTimeout(() => {
            this.onResize();
        }, 0);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false);
        window.removeEventListener('fullscreenchange', this.changeFull, false);
        window.removeEventListener('mozfullscreenchange', this.changeFull, false);
        window.removeEventListener('webkitfullscreenchange', this.changeFull, false);
        window.removeEventListener('msfullscreenchange', this.changeFull, false);
        dispatch.screen.resetAndclear({});
        // 界面取消持续weak
        sleep.noNeedWake();
        const { isAuctioneer } = this.props;
        if (isAuctioneer) {
            dispatch.longLinkListen.disconnect({});
        }
        else {
            if (isListenLong) {
                dispatch.longLinkListen.disconnect({});
            }
            else {
                dispatch.screenDetailLoop.stopLoop({});
            }
        }
        if (addPollingMechanism) {
            dispatch.screenLoop.stopLoop({});
        }
    }
    componentWillUpdate(nextProps) {
        const { isTheLast } = nextProps._state;
        const { isTheLast: oldIsTheLast } = this.props._state;
        if (isTheLast !== oldIsTheLast) {
            // 处理计算不准确的问题
            setTimeout(() => {
                this.onResize();
            }, 0);
        }
    }
    render() {
        const { sessionStatus, carInfo, isFormal, isTheLast, is268V, rank, nextCarNum, nextCarName, } = this.props._state;
        const { isFull, isFourToThree } = this.state;
        const { isAuctioneer } = this.props;
        const [styleClass__status, bidStatusText] = this.getBidStatus();
        const { carNum, carName, firstImage } = carInfo;
        const { priceStatus, price } = this.getPriceInfo();
        const content = this.getContent();
        const styleClass__container = this.getClassContainer();
        const showNumOrName = isFormal ? carNum : '模拟';
        return (<div id="_screenOuter" style={{ width: '100%', height: isAuctioneer ? '100%' : 'calc(100% - 65px)', backgroundColor: '#fff' }}>
      <Container id="_screen" isAuctioneer={isAuctioneer} isFull={isFull} isTheLast={isTheLast} sessionStatus={sessionStatus} style={{ width: '100%' }}>
        {sessionStatus === 'noBegin' &&
            <BeforeAuction />}
        {sessionStatus === 'begin' &&
            <Root isAuctioneer={isAuctioneer} isTheLast={isTheLast} isFull={isFull} isFourToThree={isFourToThree}>
            <div className="s--top flex__row-startS">
                <Button className="btn_carNum flex__row-center">{showNumOrName}</Button>
                <div className="textFlow2 top__carName">{carName}</div>
            </div>
            <div className="first_space"/>
            <div className="s--center flex__row-bt">
              <div className="center-left">
                
                <CarImgs defaultImg={firstImage ? [{ photoPathSamll: firstImage }] : ''}/>
                
                <CarLevel isAuctioneer={isAuctioneer} rank={rank} is268V={is268V}/>
              </div>
              <div className={`center-right ${styleClass__container}`}>
                <div className="center_content flex__column-start">
                  <div className="flex__row-start r-bidS__container">
                    <span className={`r-bidS ${styleClass__status}`}>{bidStatusText}</span>
                    <span className="r-bidS__desc">{priceStatus}</span>
                  </div>
                  <div className="r-p flex__column-btS">
                    
                    {this.getCurrentPrice(price)}
                    
                    {this.getTags()}
                    
                    {this.getPrices()}
                  </div>
                </div>
                <i className="resultIcon"/>
              </div>
            </div>
            <div className="second_space"/>
            <DetailInfo content={content} gutter={0} symbol={''} className={`${isAuctioneer ? 'L' : 'B'} carInfo_2`}/>
          </Root>}
        {sessionStatus === 'end' &&
            <EndAction />}
        {!isAuctioneer &&
            <i className={`${isFull ? '' : 'outOpt'} `} onClick={this.toggleFullScreen}/>}
      </Container>
      
      {!isAuctioneer && sessionStatus === 'begin' && !isTheLast &&
            <NextCar carName={nextCarName} carNumber={nextCarNum}/>}
      </div>);
    }
}
export default connect(mapStateToProps)(Screen);
